import { Icons } from '../images/icons';
import { BeersArray, CocktailsArray, FoodArray, HotDrinksArray, OtherArray, SoftsArray, WineArray, CategoriesArray } from './data';

const icons = { Food: Icons.food, Softs: Icons.soft, Beers: Icons.beer, Cocktails: Icons.cocktail, 'Hot drinks': Icons.drink, Wine: Icons.wine, Other: Icons.others };
const collections = { Food: FoodArray, Softs: SoftsArray, Beers: BeersArray, Cocktails: CocktailsArray, 'Hot drinks': HotDrinksArray, Wine: WineArray, Other: OtherArray };

export function posProductIcon(product) {
  if ((product.name || product.title) === 'Cashless activation cost') return Icons.cashless;
  const custom = product.customIcon;
  return (custom && ((collections[product.category] || CategoriesArray).find((entry) => entry.name === custom)?.icon
    || CategoriesArray.find((entry) => entry.name === custom)?.icon)) || icons[product.category] || Icons.others;
}
